// extracted by mini-css-extract-plugin
module.exports = {"Component":"Privacy_Component__2TUjC","Text_center":"Privacy_Text_center__3J2DU","Content":"Privacy_Content__OqDfa"};